import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';

import { BULLET_POINT_ICONS } from './constants';

export function Header() {
	return (
		<>
			<div className="flex flex-col gap-3">
				<Text
					className="text-size-heading-xs leading-8 md:text-size-heading-small"
					as="h3"
					variant="heading"
					fontWeight="bold"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.header.subtitle" />
				</Text>
				<Text size="medium" className="leading-6">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.header.engage_supporters" />
				</Text>
			</div>
			<div className="mt-4 flex flex-col gap-2">
				{BULLET_POINT_ICONS.map((bulletPoint, index) => (
					<div className="flex items-center gap-4" key={`bullet-point-${index + 1}`}>
						<div className="bg-fill-information-weaker flex h-11 w-11 items-center justify-center rounded-full">
							<Icon icon={bulletPoint.icon} className="text-icon-accent-primary" size="xl" />
						</div>
						<Text size="medium" className="leading-6">
							{bulletPoint.text}
						</Text>
					</div>
				))}
			</div>
		</>
	);
}
